import { jsonValue } from '@common/utils/dynamicConfig/firebase/FirebaseValueSchemas';
import { z } from 'zod';

/**
 * Configuration for the background viewings import process.
 */
export interface IViewingsImportConfig {
  enabled: boolean;
  importIntervalMinutes: number;
  errorSlackChannel: string;
}

export const viewingsImportConfigDefaults: IViewingsImportConfig = {
  enabled: true,
  importIntervalMinutes: 30,
  errorSlackChannel: 'viewing-import-errors',
};
export const viewingsImportConfigSchema = jsonValue.pipe(
  z
    .object({
      enabled: z.boolean().default(viewingsImportConfigDefaults.enabled),
      importIntervalMinutes: z.number().int().default(viewingsImportConfigDefaults.importIntervalMinutes),
      errorSlackChannel: z.string().default(viewingsImportConfigDefaults.errorSlackChannel),
    })
    .default(viewingsImportConfigDefaults),
);
